(() => {
  const sources = window.productModuleSources;
  if (!sources) return;

  let loaded = false;

  const load = () => {
    if (loaded) return;
    loaded = true;
    sources.forEach(({ src, module }) => {
      const script = document.createElement('script');
      script.src = src;
      if (module) script.type = 'module';
      document.head.appendChild(script);
    });
  };

  // Custom elements upgrade retroactively, so markup injected by quick-add before these
  // definitions land still becomes functional once they are defined.
  const onInteraction = (event) => {
    if (!event.target.closest('quick-add, [data-product-url]')) return;
    load();
  };

  if (document.querySelector('variant-options, gallery-section, model-element')) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(load, { timeout: 3000 });
    } else {
      setTimeout(load, 500);
    }
    return;
  }

  document.addEventListener('pointerdown', onInteraction, { capture: true });
  document.addEventListener('click', onInteraction, { capture: true });
})();
